module.exports = __webpack_public_path__ + "img/icon_trade_contract_trade_result_data.4ef425fc.svg";